import { useMemo } from 'react'
import { useAccount, usePublicClient } from 'wagmi'

import { Hash } from 'types/entities'

import { useToken } from 'state/airdrop/hooks'
import { useGetBalancesQuery } from 'state/balancesApi'
import { useSelfGeneratedAddress } from 'state/user/hooks'

import { isEther } from 'utils/crypto'

import { useNativeCurrency } from '../token/useNativeCurrency'

export function useGetBalancesRequest() {
  const { chain } = usePublicClient()
  const { address, isConnected } = useAccount()
  const privateKeyAddress = useSelfGeneratedAddress()

  const token = useToken()
  const nativeCurrency = useNativeCurrency()

  const tokens = useMemo(() => {
    const _tokens = [nativeCurrency]

    if (token && !isEther(token.address)) {
      _tokens.push(token)
    }

    return _tokens
  }, [token, nativeCurrency])

  const skip = useMemo(() => !isConnected || !address, [address, isConnected])
  return useGetBalancesQuery(
    { owner: address as Hash, chain, tokens, selfGenerated: privateKeyAddress || undefined },
    { skip, pollingInterval: 15_000 },
  )
}
